import { render, staticRenderFns } from "./HistoricoEdicoesDlg.vue?vue&type=template&id=6c20453a"
import script from "./HistoricoEdicoesDlg.vue?vue&type=script&lang=js"
export * from "./HistoricoEdicoesDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports